import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { InvestmentTransactions } from '../../Models/Domains/Transactions/Investments/InvestmentTransactions';

declare var IS_RUNNING_IN_APP_POOL;

export class InvestmentTransactionByTransIdClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(transId: number): Promise<InvestmentTransactions, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transaction/InvestmentTransactionByTransId/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { transId: transId }

    return AjaxWrapper.get<InvestmentTransactions, any>(url, data);
  }
}

